import React from 'react';
import AButton from '../../../../../common/form-fields-mui/AButton';
import RefreshIcon from "../../../../../../../../assets/img/svg/svgComponents/RefreshIcon";
import styles from "./styles.module.scss";
import moment from 'moment';

const DigitalConsentInProgress = ({
   email,
   phoneNo,
   digitalConsentSentDate,
   sendDigitalConsentNotification,
   enableUserActions
}) => {
   return (

      <div className={`d-flex justify-content-between ${styles['digital-consent-in-progress-card']}`} >

         <div className='d-flex justify-content-between' style={{ columnGap: '12px' }}>

            <RefreshIcon />

            <div className='d-flex justify-content-between flex-column'>
               <span className={styles['info-heading']}>Taking digital Consent</span>
               <div className={`${styles['info-sub-heading']}`}>Notification sent to {phoneNo} and email {email}</div>
               <div className={`${styles['date-time-info']}`}>{moment(digitalConsentSentDate)?.format("DD MMM YYYY, hh:mm A")}</div>
            </div>
         </div>

         {enableUserActions && <AButton
            variant='outline'
            size='xs'
            outlineVariantColor="#CCCCCC"
            textColor="#0F0F0F"
            onClick={sendDigitalConsentNotification}
         >
            Resend Notification
         </AButton>}

      </div>
   );
}

export default DigitalConsentInProgress;